<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col style="line-height: 60px;">
          <el-button round @click="freshClick">{{generateCustomizeString('refresh')}}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-form :inline="true" ref="searchForm" :model="searchForm" class="search-form-inline">
            <el-form-item :label="generateCustomizeString('stockTimeRange')">
              <el-date-picker
                v-model="searchForm.datetimeRange"
                type="datetimerange"
                :picker-options="datetimeRangePickerOptions"
                range-separator="-"
                :start-placeholder="generateCustomizeString('start')"
                :end-placeholder="generateCustomizeString('end')"
                :default-time="['00:00:00', '23:59:59']"
                align="right"
                style="width: 500px;"
              ></el-date-picker>
            </el-form-item>
            <el-tag v-if="productFullName ">{{ productFullName }}</el-tag>
            <el-col :span="24">
              <el-form-item :label="generateCustomizeString('productName')">
                <el-input
                  v-model="searchForm.goods_name"
                  :placeholder="generateCustomizeString('productName')"
                  resize="horizontal"
                  style="width: 220px;"
                ></el-input>
              </el-form-item>
              <el-form-item :label="generateCustomizeString('productSku')">
                <el-input
                  v-model="searchForm.bar_code"
                  :placeholder="generateCustomizeString('productSku')"
                  resize="horizontal"
                  style="width: 210px;"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSearch">{{generateCustomizeString('search')}}</el-button>
                <el-button @click="onReset">{{generateCustomizeString('reset')}}</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <el-table
        :data="stockData"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom:60px;"
        v-loading.body="stockListLoading"
      >
        <el-table-column :label="generateCustomizeString('barcode')" width="180">
          <template slot-scope="scope">
            <span>{{scope.row.goods_sku.bar_code}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('merchandiseThumbnail')" width="130">
          <template slot-scope="scope">
            <img
              v-if="scope.row.first_image_url.length"
              :src="scope.row.first_image_url + '?imageView2/1/w/200/h/200/q/75|imageslim'"
              style="width:auto;height:100px;"
            />
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('merchandiseName')" width="200">
          <template slot-scope="scope">
            <span>{{scope.row.product_full_name}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('orderId')" width="140">
          <template slot-scope="scope">
            <el-button
              @click="viewOrderClick(scope.row)"
              type="text"
              v-if="scope.row.out_trade_no !== null"
            >{{scope.row.out_trade_no}}</el-button>
            <span v-else>{{ generateCustomizeString('none') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="stockValue"
          :label="generateCustomizeString('stockValue')"
          width="200"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.operation_type === 1"
            >{{ generateCustomizeString('operate')}}: + {{scope.row.quantity}}</span>
            <span v-else>{{ generateCustomizeString('operate') }}: - {{scope.row.quantity}}</span>
            <p />
            <div
              v-if="!(scope.row.stock_before === 0 && scope.row.stock_after === 0)"
            >{{ generateCustomizeString('stockBeforeValue') }}: {{scope.row.stock_before}}</div>
            <div
              v-if="!(scope.row.stock_before === 0 && scope.row.stock_after === 0)"
            >{{ generateCustomizeString('stockAfterValue') }}: {{scope.row.stock_after}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="stockOperationType"
          :label="generateCustomizeString('stockOperationType')"
          width="200"
        >
          <template slot-scope="scope">
            <span>{{ generateCustomizeString(scope.row.status_name) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('stockOperationInformation')" width="250">
          <template slot-scope="scope">
            <span>{{ generateCustomizeString('operator') }}: {{scope.row.operator}}</span>
            <p />
            <span>{{ generateCustomizeString('time') }}: {{scope.row.created_at | toLocalTime}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="130">
          <template slot-scope="scope">
            <el-button
              @click="viewClick(scope.row)"
              type="text"
              size="small"
            >{{generateCustomizeString('viewAllSkuStock')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:10px;">
      <el-row type="flex">
        <el-col style="padding-top: 5px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfGoods"
            layout="total, prev, pager, next"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
        <el-col>
          <div style="position: fixed; right: 30px;">
            <span style="font-size: 14px; color: #606266;">{{ generateCustomizeString('perPage') }}</span>
            <el-select v-model="numOfGoods" style="width: 100px;" @change="selectNumOfGoods()">
              <el-option
                v-for="item in numOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

const originOrderSearchFrom = {
  datetimeRange: [],
  goods_sku_id: '',
  goods_name: '',
  bar_code: ''
}

export default {
  name: 'StockList',
  props: {
    isStockStatus: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      searchForm: Object.assign({}, originOrderSearchFrom),
      stockData: [],
      stockListLoading: false,
      currentPage: 1,
      currentTotal: 0,
      multipleSelection: [],
      categoriesOptions: [],
      brandOptions: [],
      dialogStockFormVisible: false,
      productFullName: '',
      goodsSkuId: null,
      filters: {},
      numOfGoods: 15,
      numOptions: [
        {
          value: 15,
          label: '15'
        },
        {
          value: 50,
          label: '50'
        },
        {
          value: 100,
          label: '100'
        }
      ],
      datetimeRangePickerOptions: {
        shortcuts: [
          {
            text: this.generateCustomizeString('lastWeek'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(1, 'week')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          },
          {
            text: this.generateCustomizeString('lastMonth'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(1, 'month')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          },
          {
            text: this.generateCustomizeString('lastThreeMonths'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(3, 'month')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          }
        ]
      }
    }
  },
  activated() {
    this.fetchStockData(1)
  },
  methods: {
    generateCustomizeString,
    selectNumOfGoods() {
      this.fetchStockData(1)
    },
    onSearch() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          if (
            this.searchForm.datetimeRange &&
            this.searchForm.datetimeRange.length === 2
          ) {
            const dates = this.searchForm.datetimeRange.map(date =>
              dayjs(date)
                .utc()
                .format('YYYY-MM-DD HH:mm:ss')
            )
            params.start_created_at = dates[0]
            params.end_created_at = dates[1]
            delete params.datetimeRange
          }

          if (this.goodsSkuId) {
            params.goods_sku_id = this.goodsSkuId
          }
          console.log(params)
          this.filters = params
          this.fetchStockData(1)
        } else {
          console.log('data error')
        }
      })
    },
    getLocalTime(date, i) {
      // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
      if (typeof i !== 'number') return
      var d = new Date(date)
      // 得到1970年一月一日到现在的秒数
      var len = d.getTime()
      // 本地时间与GMT时间的时间偏移差
      var offset = d.getTimezoneOffset() * 60000
      // 得到现在的格林尼治时间
      var utcTime = len + offset
      return new Date(utcTime - 3600000 * i)
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.searchForm = Object.assign({}, originOrderSearchFrom)
      this.filters = {}
      this.productFullName = ''
      this.goodsSkuId = null
      this.fetchStockData(1)
    },
    viewClick(row) {
      this.productFullName = row.product_full_name
      this.goodsSkuId = row.goods_sku_id
      if (this.isStockStatus) {
        this.$router.push({
          name: 'AllStock',
          params: {
            goodsSkuId: row.goods_sku_id,
            productFullName: row.product_full_name
          }
        })
      } else {
        this.filters.goods_sku_id = row.goods_sku_id
        this.fetchStockData(1)
      }
    },
    viewOrderClick(row) {
      this.$router.push({
        name: 'All',
        params: { outTradeNo: row.out_trade_no }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    editStockClick(row) {
      this.dialogStockFormVisible = !this.dialogStockFormVisible
    },
    updateStockClick() {
      // TODO
      this.dialogStockFormVisible = false
    },
    dismissStockDialog() {
      this.dialogStockFormVisible = false
    },
    onSubmit() {
      console.log('submit!')
    },
    freshClick() {
      this.fetchStockData(this.currentPage)
    },
    handleChange(value) {
      console.log(value)
    },
    handleCurrentChange(val) {
      this.fetchStockData(val)
    },
    fetchCategories() {
      return new Promise((resolve, reject) => {
        request({
          url: '/categories',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].name
              const sub = response.data[i].sub_categories
              for (let j = 0; j < response.data[i].sub_categories.length; j++) {
                var sobj = {}
                sobj.value = response.data[i].sub_categories[j].id
                sobj.label = response.data[i].sub_categories[j].name
                sub[j] = sobj
              }
              obj.children = sub
              data[i] = obj
            }
            this.categoriesOptions = data
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
      })
    },
    fetchBrand() {
      return new Promise((resolve, reject) => {
        request({
          url: '/brands?pages=all',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].brand_name
              data[i] = obj
            }
            this.brandOptions = data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchStockData(page) {
      if (this.stockListLoading) return
      this.stockListLoading = true

      if (this.$route.params.goodsSkuId) {
        this.productFullName = this.$route.params.productFullName
        this.goodsSkuId = this.$route.params.goodsSkuId
        this.filters.goods_sku_id = this.$route.params.goodsSkuId
        this.filters.start_created_at = ''
        this.filters.end_created_at = ''
        this.searchForm.datetimeRange = []
        this.$route.params.goodsSkuId = null
      }

      const url = this.isStockStatus
        ? '/goods-stock-operation-logs-list?operation_type=' +
          this.isStockStatus
        : '/goods-stock-operation-logs-list'

      request({
        url: url,
        method: 'get',
        params: {
          page: page,
          page_size: this.numOfGoods,
          ...this.filters
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          this.stockData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.stockListLoading = false
        })
    }
  },
  created: function() {
    this.fetchBrand()
    this.fetchCategories()
    this.fetchStockData(1)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
  // text-align: left;
  // line-height: 60px;
}

.search-form-inline {
  // padding-top: 10px;
  // text-align: right;
  max-height: 60px;
  // background-color: #eee;
}
</style>
